// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"465":"25c89022","817":"d298e1ea","864":"43961fc6"}[chunkId] + ".chunk.css";
};